/**
 * CAMPAIGN W1.4 — full-screen act/title cards (BLACK MARBLE; ACT N — ...).
 * While a card is open the frame loop renders but does NOT step the sim
 * (same routing idea as DOCKED). Dismiss on click/Enter or auto after HOLD_SEC.
 */
import './chapterCard.css';

const HOLD_SEC = 6; // auto-dismiss after this long (click/Enter dismisses sooner)

export class ChapterCard {
  private readonly root: HTMLDivElement;
  private open = false;
  private t = 0;
  private onDismiss: (() => void) | null = null;

  constructor() {
    this.root = document.createElement('div');
    this.root.id = 'chapter-card';
    this.root.style.display = 'none';
    document.body.appendChild(this.root);

    this.root.addEventListener('click', () => this.dismiss());
    window.addEventListener('keydown', (e) => {
      if (this.open && (e.key === 'Enter' || e.key === ' ')) this.dismiss();
    });
  }

  get isOpen(): boolean {
    return this.open;
  }

  show(title: string, sub?: string, onDismiss?: () => void): void {
    this.open = true;
    this.t = 0;
    this.onDismiss = onDismiss ?? null;
    this.root.innerHTML = `
      <div class="cc-inner">
        <div class="cc-title">${title}</div>
        ${sub ? `<div class="cc-sub">${sub}</div>` : ''}
        <div class="cc-dismiss">CONTINUE [ENTER]</div>
      </div>`;
    this.root.style.display = 'flex';
    requestAnimationFrame(() => this.root.classList.add('shown'));
  }

  /** Advance the auto-dismiss clock (called per frame while open). */
  tick(dt: number): void {
    if (!this.open) return;
    this.t += dt;
    if (this.t >= HOLD_SEC) this.dismiss();
  }

  dismiss(): void {
    if (!this.open) return;
    this.open = false;
    this.root.classList.remove('shown');
    this.root.style.display = 'none';
    const cb = this.onDismiss;
    this.onDismiss = null;
    cb?.();
  }
}
